import { PerspectiveCamera, Vector3 } from 'three';

const BASE_FOV = 62;
const FOV_PER_SPEED = 0.45;

/** Third-person camera behind the trotro that widens with speed and shakes on hits. */
export class ChaseCamera {
  readonly camera = new PerspectiveCamera(BASE_FOV, 1, 0.1, 400);
  private readonly look = new Vector3();
  private shake = 0;
  /** The camera's lane-following position, kept apart from the turn so it eases back smoothly. */
  private baseX = 0;

  setAspect(aspect: number): void {
    this.camera.aspect = aspect;
    // Portrait phones: pull back so the lanes still fit.
    this.camera.fov = aspect < 1 ? BASE_FOV + 14 : BASE_FOV;
    this.camera.updateProjectionMatrix();
  }

  kick(amount: number): void {
    this.shake = Math.max(this.shake, amount);
  }

  /** Jump straight to the lane position (after the world has turned round). */
  snap(busX: number): void {
    this.baseX = busX * 0.55;
    this.camera.position.x = this.baseX;
  }

  /**
   * `heading` is how far the trotro has turned (radians, 0 = along the road). While it turns, the camera swings
   * round behind it, so the U-turn is seen from the driver's side.
   */
  follow(busX: number, busY: number, busZ: number, speed: number, dt: number, heading = 0): void {
    const cam = this.camera;
    this.baseX += (busX * 0.55 - this.baseX) * Math.min(1, dt * 6);
    const w = Math.min(1, heading / 0.6);
    const sin = Math.sin(heading);
    const cos = Math.cos(heading);
    cam.position.x = this.baseX + (busX + 10.5 * sin - this.baseX) * w;
    cam.position.y = 5.2 + busY * 0.5;
    cam.position.z = busZ + 10.5 + (10.5 * cos - 10.5) * w;
    this.shake = Math.max(0, this.shake - dt * 2.5);
    if (this.shake > 0) {
      cam.position.x += (Math.random() - 0.5) * this.shake;
      cam.position.y += (Math.random() - 0.5) * this.shake;
    }
    this.look.set(busX * 0.8 + (busX - 14 * sin - busX * 0.8) * w, 1.2, busZ - 14 + (-14 * cos + 14) * w);
    cam.lookAt(this.look);

    const wantedFov = (this.camera.aspect < 1 ? BASE_FOV + 14 : BASE_FOV) + speed * FOV_PER_SPEED;
    cam.fov += (wantedFov - cam.fov) * Math.min(1, dt * 3);
    cam.updateProjectionMatrix();
  }
}
